import { commonColors } from "./constants"

const TabPrimaryColor = '#101828'
const lightTextPrimary = '#101828'
const lightBackgroundColor = '#F8F8F8'
const lightBorder = '#1D2939'

const appBackground = '#FFFFFF'
const dark5 = '#EBEBEB'

export const lightColors = {
  ...commonColors,
  appBackground: appBackground,
  pageHeaderBackground: `linear-gradient(180deg, ${dark5} 0.52%, ${lightBackgroundColor} 100%)`,
  dark1: appBackground,
  dark2: appBackground,
  dark3: '#F9FAFB',
  // dark4: '#F2F4F7',
  dark4:'#929292',
  dark5: dark5,
  dark6: appBackground,
  dark7: appBackground,
  dark8: appBackground,
  dark9:appBackground,
  dark10:'#a8e3c6',
  darkMain: appBackground,
  TabPrimaryColor:TabPrimaryColor,
  textPrimary: lightTextPrimary,
  textSecondary: '#344054',
  paragraphColor: lightTextPrimary,
  tooltip:lightTextPrimary,
  divider: lightBorder,
  backdrop: lightBackgroundColor+'66',
  disabled: lightTextPrimary+'8a',
  icon: lightTextPrimary+'8a',
  headerBorder: lightTextPrimary+'4d',
  paperBorder: {
    border: `1px solid ${lightBorder}`,
    boxShadow: 'unset'
  },
  // research
  prograssBarColor: '#667085',
  prograssBarBackground: dark5, 
  correlationCardBorder: lightTextPrimary,
  correlationCardBackground: dark5,
  selectedItem: commonColors.ctaPrimary,
  datasetBorder: lightBorder,
  //dashboard
  treemapBackground: dark5
}
